var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("badge " + (_vm.statusVariant.class))},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.$t(_vm.statusVariant.label_key))+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }